<template>
  <v-row>
    <v-col
      cols="12"
      md="4"
      lg="3"
      xl="2"
    >
      <api-key-manager />
    </v-col>

    <v-col
      cols="12"
      md="4"
      lg="3"
      xl="2"
    >
      <v-card>
        <v-card-title class="px-12">
          <v-img :src="require('@/assets/images/zapier-logo.png')" />
        </v-card-title>

        <v-card-text>
          Integrate Atlas with 1000+ apps
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            text
            href="https://zapier.com/developer/public-invite/29658/d3081272d33443249e5a8bdc9e95e187/"
            target="_blank"
          >
            Go To Zapier
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ApiKeyManager from './ApiKeyManager'

export default {
  name: 'Integrations',
  components: {
    ApiKeyManager
  },
  methods: {
    // connectApp (app) {
    //   const integration = getIntegration(app)

    //   let url = integration.authUrl
    //   url += `?client_id=${integration.clientId}`
    //   url += `&redirect_uri=${encodeURIComponent(getRedirectUri(app))}`
    //   url += '&response_type=code'

    //   if (integration.additionalData) {
    //     for (const key in integration.additionalData) {
    //       url += `&${key}=${encodeURIComponent(integration.additionalData[key])}`
    //     }
    //   }

    //   firebase.auth().currentUser.getIdToken(true)
    //     .then(token => {
    //       url += `&state=${token}`
    //       window.open(url, `Authorize ${app}`, 'resizable,status,scrollbars,height=600,width=500')
    //     })
    //     .catch(err => {
    //     })
    // },
  }
}
</script>
